import React from 'react';
import { Skeleton } from '@material-ui/lab';

const SkeletonBanner = ({ children }) => (
  <div>
    <a>
      <Skeleton width="100%" variant="rect">
        {children}
      </Skeleton>
    </a>
  </div>
);

export default SkeletonBanner;


// WEBPACK FOOTER //
// ./src/components/Skeleton/SkeletonBanner.jsx